import React from "react"
import tw from "twin.macro"
import { Typography } from "./Typography"

export const Heading = ({ title }: { title: string }) => (
  <Typography variant="h1" css={tw`mb-8 mt-6`}>
    {title}
  </Typography>
)
